var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"order-info-tile c:row-between-center"},[_c('div',{staticClass:"order-info-tile-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"order-info-tile-value"},[_vm._v(_vm._s(_vm.valueText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }